import { EMPLOYED_STATUS_CODES, STUDENT_STATUS_CODES, DLN_GENDER_CODES } from './constants';

/**
 * Checks if an employment status indicates employed
 */
export const isEmployed = (employmentStatus: string) => {
	return EMPLOYED_STATUS_CODES.includes(employmentStatus);
};

/**
 * Checks if an employment status indicates student
 */
export const isStudent = (employmentStatus: string) => {
	return STUDENT_STATUS_CODES.includes(employmentStatus);
};

// Re-export constants for direct access
export { EMPLOYED_STATUS_CODES, STUDENT_STATUS_CODES, DLN_GENDER_CODES };
